import Routes from 'Routes';
import { saveOldLocation } from '../../modules/actions';
import { gspCollect } from '@csair/emp-helpers';

export default store => ({
  path: Routes.ticket.child.pay.key,
  onEnter(nextState, replace, callback) {
    window.$sensors.sensors.track('flight_ticket_refund_and_change_page_view', {
      page_name: '机票退改-支付成功页',
      channel_id: nextState.location.query.channel
        ? nextState.location.query.channel
        : '',
      refund_change_order_id: nextState.location.query.orderNo,
    });
    callback();
  },
  onLeave(prevState) {
    store.dispatch(saveOldLocation(prevState.location));
  },
  getComponent(nextState, cb) {
    require.ensure(
      [],
      require => {
        const pay = require('./components/Pay').default;
        cb(null, pay);
      },
      'login'
    );
  },
});



// WEBPACK FOOTER //
// ./src/routes/routes/pay/index.js